import React from 'react';

import { noop } from 'src/utils/common';
import { ModalParams } from './types';

export const ModalContext = React.createContext({
  modalParams: {} as ModalParams,
  isModalOpen: false,
  onCloseModal: noop,
  onOpenModal: (modal: ModalParams) => {
    console.log('modal', modal);
  },
});
